import { useState, useEffect } from "react";
import config from "../../config";

const UserProfile = ({ userId }) => {
  const [userData, setUserData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [status, setStatus] = useState(null);
  const [errors, setError] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
  });

  // Récupérer les infos de l'utilisateur depuis l'API
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/api/admin/getuser`,
          {
            method: "GET",
            credentials: "include",
          }
        );

        const data = await response.json();

        if (data.isSuccess) {
          setUserData(data.result); // Mise à jour des informations de l'utilisateur
          setFormData({
            email: data.result.email,
            username: data.result.username,
            password: "", // Optionnel si tu ne veux pas remplir le mot de passe dans le formulaire
          });
        }
      } catch (error) {
        console.error("Erreur lors du chargement des informations:", error);
        setError("Erreur lors du chargement des informations.");
      }
    };

    fetchUserData();
  }, [userId]);

  // Gérer les changements dans le formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Envoyer les modifications à l'API
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedFields = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== userData[key] && formData[key] !== "") {
        updatedFields[key] = formData[key];
      }
    });

    // Si aucun champ n'a changé, on ne fait rien
    if (Object.keys(updatedFields).length === 0) {
      setStatus("Aucune modification détectée.");
      return;
    }

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/api/admin/modifuser`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(updatedFields), // Envoie seulement les champs modifiés
        }
      );

      const data = await response.json();

      if (data.isSuccess) {
        // Mise à jour de userData avec les nouvelles informations
        setUserData(data.result); // Les nouvelles informations de l'utilisateur
        setIsEditing(false); // Sortir du mode édition
        setStatus("Modifications enregistrées !");
      } else {
        setError("Erreur lors de l'enregistrement.");
      }
    } catch (error) {
      setError("Erreur lors de l'enregistrement.");
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col justify-center items-center">
      <div className="w-full md:w-2/3 lg:w-1/2 bg-light rounded-2xl shadow-lg p-8 flex flex-col space-y-6 items-center">
        {/* Message de statut */}
        {status && (
          <div className="bg-deepblue text-light px-4 py-2 rounded-lg shadow-md mb-4">
            {status}
          </div>
        )}
        {errors && (
          <div className="bg-primary text-light px-4 py-2 rounded-lg shadow-md mb-4">
            {errors}
          </div>
        )}

        <h3 className="text-3xl font-bold text-center text-dark">Profil Utilisateur</h3>

        {userData && !isEditing ? (
          // Affichage des informations utilisateur
          <div className="w-11/12 md:w-2/3 lg:w-1/2 p-4 text-center items-center">
            <p className="text-2xl font-semibold text-center text-dark mb-6">
              Nom : {userData.username}
            </p>
            <p className="text-2xl font-semibold text-center text-dark mb-6">
              Email : {userData.email}
            </p>

            <button
              onClick={() => setIsEditing(true)}
              className="mt-4 px-4 py-2 bg-accent text-white rounded-lg hover:bg-deepblue transition"
            >
              Modifier mes infos
            </button>
          </div>
        ) : (
          // Formulaire d'édition des informations
          <form
            onSubmit={handleSubmit}
            className="w-full md:w-2/3 lg:w-1/2 bg-white text-dark p-8 rounded-2xl shadow-lg flex flex-col space-y-4"
          >
            <input
              type="text"
              name="username"
              placeholder="Nom"
              value={formData.username}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:accent"
            />

            {/* Email */}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:accent"
            />
            <input
              type="password"
              name="password"
              placeholder="Mot de passe"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:accent"
            />
            {/* Boutons */}
            <div className="flex space-x-4">
              <button
                type="submit"
                className="w-1/2 bg-accent text-white p-3 rounded-lg font-semibold hover:bg-deepblue transition"
              >
                Enregistrer
              </button>
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="w-1/2 bg-gray-400 text-white p-3 rounded-lg font-semibold hover:bg-gray-600 transition"
              >
                Annuler
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
